import * as React from 'react';

import { Form } from '@independent-software/typeui/controls/Form';
import { Dialog } from '@independent-software/typeui/controls/Dialog';
import { Panel } from '@independent-software/typeui/controls/Panel';
import { DataTable } from '@independent-software/typeui/controls/DataTable';
import { Gravatar } from '@independent-software/typeui/controls/Gravatar';
import { Input } from '@independent-software/typeui/controls/Input';
import { Datum } from '@independent-software/typeui/formatters/Datum';

import { IAuth } from '../../AuthContext';
import { List, IListState, IListProps, SearchFilter } from '../../services/';
import { User, UserFactory } from '../../resource/';
import { IconBar, Export } from '../../modules';

interface IListUsersProps extends IListProps {
  /**
   * Event is fired when a user is clicked.
   */
  onClick?: (user:User) => void;
}

interface IListUsersState extends IListState<User> {
}

class ListUsers extends List<User, IListUsersProps, IListUsersState> {
  constructor(props: IAuth & IListUsersProps) {
    super(props, UserFactory, 'name', 'asc');

    this.state = {
      ...this.state
    };
  }

  handleSearch = (value:string) => {
    this.setFilter('q', 'like', value);
  }

  handleChangeFromDate = (value:string) => {
    this.setFilter('date', 'gte', value);
  }

  handleChangeToDate = (value:string) => {
    this.setFilter('date', 'lte', value);
  }

  render() {
    let p = this.props;

    let filter =
    <React.Fragment>
      <Panel.Content>
        <Form.Uncontrolled hint="Type to search records">
          <SearchFilter value={this.getFilter('q', 'like')} onSearch={this.handleSearch}/>
        </Form.Uncontrolled>
        <Form.Uncontrolled hint="Filter by start date">
          <Input name="from" type="date" fluid clearable value={this.getFilter('date', 'gte')} placeholder="From date" onChange={this.handleChangeFromDate}/>
        </Form.Uncontrolled>
        <Form.Uncontrolled hint="Filter by end date">
          <Input name="to" type="date" fluid clearable value={this.getFilter('date', 'lte')} placeholder="To date" onChange={this.handleChangeToDate}/>
        </Form.Uncontrolled>
      </Panel.Content>
      <Panel.Footer>
        <div style={{display: "flex", justifyContent: 'flex-end'}}>
          <Export onExport={this.handleExport}/>
        </div>
      </Panel.Footer>
    </React.Fragment>

    return (
      <React.Fragment>
        <IconBar>
          <Panel.Icon icon="tools" width={350}>
            {filter}
          </Panel.Icon>
        </IconBar>
        <DataTable error={this.state.error} loading={this.state.loading} scrollTop={this.state.scrollTop} onScroll={this.handleScroll} data={this.state.items} onFetch={this.handleFetch} onClick={p.onClick} onOrder={this.handleOrder} order={this.getOrder()} dir={this.getDir()}>
          <DataTable.Column weight={2} label="Name" order="name" dir="asc">{(item:User) => <span><Gravatar email={item.email}/> {item.name}</span>}</DataTable.Column>
          <DataTable.Column weight={2} label="Email" order="email" dir="asc">{(item:User) => item.email}</DataTable.Column>
          <DataTable.Column label="Roles">{(item:User) => (item.roles ?? []).join(', ')}</DataTable.Column>
          <DataTable.Column label="Last seen" order="login_at" dir="desc">{(item:User) => item.login_at ? <Datum.Distance value={item.login_at}/> : "never"}</DataTable.Column>
        </DataTable>
        <Dialog.Xhr open={this.state.exportError != null} error={this.state.exportError} onClose={this.handleCloseDialog}/>
      </React.Fragment>
    );
  }
}

export { ListUsers };
